module.exports = __webpack_public_path__ + "media/application/images/icons/1-white-7f595facf7689774ab3a98599990867c.svg";